import * as api from "../Services/api.js";
import Transmittal from "../../objs/Transmittal";

export const state = {
  transmittals: [],
};

export const mutations = {
  SET_TRANSMITTALS(state, payload) {
    state.transmittals = payload.map((item) => new Transmittal(item));
  },
  ADD_TRANSMITTALS(state, payload) {
    payload.map((item) => {
      state.transmittals.push(new Transmittal(item));
    });
  },
  UPDATE_TRANSMITTAL(state, payload) {
    var index = state.transmittals.findIndex(
      (item) => item.transmittalId === payload.transmittalId
    );
    state.transmittals.splice(index, 1, new Transmittal(payload));
  },
  CLEAR_TRANSMITTALS(state) {
    state.transmittals = [];
  },
  REPLACE_TRANSMITTAL(state, payload) {
    var index = state.transmittals.findIndex(
      (item) => item.transmittalId === payload.old
    );
    state.transmittals.splice(index, 1, new Transmittal(payload.new));
  },
};

export const getters = {};

export const actions = {
  async uploadTransmittalReport({ commit }, data) {
    return await api
      .uploadFile(
        "/transmittal/uploadTransmittalReport",
        { programId: data.programId, semesterId: data.semesterId },
        data.selectedFile
      )
      .then((response) => {
        if (response.success) {
          commit("ADD_TRANSMITTALS", response.data);
          return "";
        }
        return response.message;
      });
  },
  async getAllUnprocessedTransmittals({ commit }, data) {
    return await api
      .get("/transmittal/getAllUnprocessedTransmittals", data)
      .then((response) => {
        if (response.success) {
          commit("SET_TRANSMITTALS", response.data);
        }
        return response.success;
      });
  },
  async getAllPendingTransmittals({ commit }, data) {
    return await api
      .get("/transmittal/getAllPendingTransmittals", data)
      .then((response) => {
        if (response.success) {
          commit("SET_TRANSMITTALS", response.data);
        }
        return response.success;
      });
  },
  async clearTransmittals({ commit }) {
    commit("CLEAR_TRANSMITTALS");
  },
  async searchTransmittals({ commit }, data) {
    return await api
      .post("/transmittal/searchTransmittals", data)
      .then((response) => {
        if (response.success) {
          commit("SET_TRANSMITTALS", response.data);
        }
        return response.success;
      });
  },
  async reprocessTransmittal({ commit }, data) {
    return await api
      .postQuery("/transmittal/reprocessTransmittal", data)
      .then((response) => {
        if (response.success) {
          commit("REPLACE_TRANSMITTAL", {
            old: data.transmittalId,
            new: response.data,
          });
          return "";
        }
        return response.message;
      });
  },
  async acceptTransmittals({ commit }, data) {
    return await api
      .post("/transmittal/acceptTransmittals", data)
      .then((response) => {
        if (response.success) {
          for (const el of response.data) {
            commit("UPDATE_TRANSMITTAL", el);
          }
          return "";
        }
        return response.message;
      });
  },
  async rejectTransmittals({ commit }, data) {
    return await api
      .post("/transmittal/rejectTransmittals", data)
      .then((response) => {
        if (response.success) {
          for (const el of response.data) {
            commit("UPDATE_TRANSMITTAL", el);
          }
          return "";
        }
        return response.message;
      });
  },
  async revokeTransmittals({ commit }, data) {
    return await api
      .post("/transmittal/revokeTransmittals", data)
      .then((response) => {
        if (response.success) {
          for (const el of response.data) {
            commit("UPDATE_TRANSMITTAL", el);
          }
          return "";
        }
        return response.message;
      });
  },
  async refuseTransmittals({ commit }, data) {
    return await api
      .post("/transmittal/refuseTransmittals", data)
      .then((response) => {
        if (response.success) {
          for (const el of response.data) {
            commit("UPDATE_TRANSMITTAL", el);
          }
          return "";
        }
        return response.message;
      });
  },
  async resolveTransmittal({ commit }, data) {
    return await api
      .postQuery("/transmittal/resolveTransmittal", data)
      .then((response) => {
        if (response.success) {
          commit("UPDATE_TRANSMITTAL", response.data);
          return "";
        }
        return response.message;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
